export default __webpack_public_path__ + "static/media/libsyn.3f0465e2.png";